// src/components/MenuLayout.js
import React, { useRef } from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment'; // For Contracts
import PaymentIcon from '@mui/icons-material/Payment'; // For Payments
import InfoIcon from '@mui/icons-material/Info'; // For Inform Payment
import {
  CampaignSharp,
  MergeTypeSharp,
  ReceiptSharp,
} from '@mui/icons-material';
import ReceiptLongSharpIcon from '@mui/icons-material/ReceiptLongSharp';
import html2canvas from 'html2canvas';
const MenuLayout = () => {
  const layoutRef = useRef(null); // Ref to capture the layout
  const handleSaveAsPng = () => {
    if (layoutRef.current) {
      html2canvas(layoutRef.current, {
        width: 2500, // Exact width
        height: 843, // Exact height
        scale: 1, // 1:1 pixel ratio to match exact size
      })
        .then((canvas) => {
          // Convert canvas to PNG and trigger download
          const link = document.createElement('a');
          link.download = 'menu-layout.png';
          link.href = canvas.toDataURL('image/png');
          link.click();
        })
        .catch((error) => {
          console.error('Error generating PNG:', error);
        });
    }
  };

  return (
    <>
      <Box
        ref={layoutRef}
        sx={{
          margin: '100px',
          width: '2500px',
          height: '843px',
          backgroundColor: '#fb1454', // Light gray background
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          padding: '40px',
        }}
      >
        {/* Contracts Button */}
        <IconButton
          sx={{
            width: '750px',
            height: '750px',
            backgroundColor: '#fff',
            borderRadius: '30px', // Slightly rounded square (use 0px for fully square)
            boxShadow: '0px 20px 50px rgba(0, 0, 0, 0.55)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: '#4b4b4b', // Dark gray on hover
              '& .MuiSvgIcon-root': { color: '#fff' }, // White icon
              '& .MuiTypography-root': { color: '#fff' }, // White text
            },
          }}
        >
          <ReceiptLongSharpIcon sx={{ fontSize: '400px', color: '#d82759' }} />
          <Typography
            variant="h4"
            sx={{
              backgroundColor: '#4b4b4b',
              color: '#fff',
              marginTop: '20px', // Space between icon and text
              padding: '30px',
              borderRadius: '50px',
              fontSize: '3em',
              width: '550px',
              boxShadow: '0px 10px 10px rgba(0, 0, 0, 0.55)',
            }}
          >
            การ์ดลูกหนี้
          </Typography>
        </IconButton>

        {/* Payments Button */}
        <IconButton
          sx={{
            width: '750px',
            height: '750px',
            backgroundColor: '#fff',
            borderRadius: '30px', // Slightly rounded square (use 0px for fully square)
            boxShadow: '0px 20px 50px rgba(0, 0, 0, 0.55)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: '#4b4b4b',
              '& .MuiSvgIcon-root': { color: '#fff' },
              '& .MuiTypography-root': { color: '#fff' },
            },
          }}
        >
          <PaymentIcon sx={{ fontSize: '400px', color: '#d82759' }} />
          <Typography
            variant="h4"
            sx={{
              backgroundColor: '#4b4b4b',
              color: '#fff',
              marginTop: '20px', // Space between icon and text
              padding: '30px',
              borderRadius: '50px',
              fontSize: '3em',
              width: '550px',
              boxShadow: '0px 10px 10px rgba(0, 0, 0, 0.55)',
            }}
          >
            ชำระเงิน
          </Typography>
        </IconButton>

        {/* Inform Payment Button */}
        <IconButton
          sx={{
            width: '750px',
            height: '750px',
            backgroundColor: '#fff',
            borderRadius: '30px', // Slightly rounded square (use 0px for fully square)
            boxShadow: '0px 20px 50px rgba(0, 0, 0, 0.55)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: '#4b4b4b',
              '& .MuiSvgIcon-root': { color: '#fff' },
              '& .MuiTypography-root': { color: '#fff' },
            },
          }}
        >
          <CampaignSharp sx={{ fontSize: '400px', color: '#d82759' }} />
          <Typography
            variant="h4"
            sx={{
              backgroundColor: '#4b4b4b',
              color: '#fff',
              marginTop: '20px', // Space between icon and text
              padding: '30px',
              borderRadius: '50px',
              fontSize: '3em',
              width: '550px',
              boxShadow: '0px 10px 10px rgba(0, 0, 0, 0.55)',
            }}
          >
            แจ้งชำระเงิน
          </Typography>
        </IconButton>
      </Box>
      {/* Save Button (outside the captured layout) */}
      <Box sx={{ position: 'absolute', top: '10px', right: '10px' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveAsPng}
          sx={{
            backgroundColor: '#4b4b4b',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          Save as PNG
        </Button>
      </Box>
    </>
  );
};

export default MenuLayout;
